import { all } from 'redux-saga/effects';
import { lookupSaga } from '../lookup/lookup.saga';
import { candidateInterviewSaga } from '../candidate-interviews/interviews.saga';
import { casesSaga } from '../cases/saga';

function* rootSaga() {
  yield all([lookupSaga(), candidateInterviewSaga(), casesSaga()]);
}

export default rootSaga;
